module.exports = __webpack_public_path__ + "static/img/purple-power-slug_256.015c203.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/purple-power-slug_256.png
// module id = Akk5
// module chunks = 0